import { fetchWithAuth } from '../apiClient';

export async function fetchServiceStatus() {
  const response = await fetchWithAuth('/scheduler/status');
  const data = await response.json();
  return {
    automationEnabled: data?.automationEnabled !== false,
    message: data?.message || 'Ekkos is in recovery mode and temporarily paused.',
  };
}
